module.exports = __webpack_public_path__ + "img/home-about-医学培训.19ee1169.png";